import React from 'react';

function SuggestedSwaps({ swapExercises = [] }) {
    return (
        <div className="swap-exercises-list-container">
            <label className="swap-exercises-label">Suggested Swaps</label>
            {swapExercises.length > 0 ? (
                swapExercises.map(s => (
                    <div
                        key={s.exerciseId || s.title}
                        className="swap-exercise-chip"
                    >
                        <span>{s.title}</span>
                    </div>
                ))
            ) : (
                <p className="swap-exercises-empty">Add swaps in the library</p>
            )}
        </div>
    );
}

export default SuggestedSwaps;



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/SuggestedSwaps.jsx